import React, { Component } from 'react'
import { Radio } from 'hljd'
import { observer, inject } from 'mobx-react'
import Chart from './Chart'
import { Action } from 'hljd'
import styles from '../style.module.less'
const RadioButton = Radio.Button
const RadioGroup = Radio.Group

@inject('store')
@observer
export default class extends Component {
  render() {
    const {
      trendTab,
      changValue,
      changField,
      typeTab,
      trend,
      tabArray,
      tab
    } = this.props.store

    return (
      <div className={styles.block}>
        <p className={styles.title}>{tabArray[tab]}数据趋势</p>

        <RadioGroup value={trendTab} onChange={changValue('trendTab')}>
          <RadioButton value="7">近7日</RadioButton>
          <RadioButton value="30">近30日</RadioButton>
          <RadioButton value="60">近60日</RadioButton>
        </RadioGroup>

        <Action
          active={typeTab}
          onChange={changField}
          options={[
            { title: '曝光量', value: '1' },
            { title: '访问量', value: '2' },
            { title: 'CTR', value: '3' },
            { title: '平均停留时长(s)', value: '4' },
            { title: `${tabArray[tab]}质量分`, value: '5' }
          ]}
        />

        <Chart data={trend} tab={typeTab} />
      </div>
    )
  }
}
